import { AD_ACTIVE_BUT_HIDDEN, AD_ACTIVE } from 'common/lib/helpers/constants';
import { formatPriceLabel } from 'common/lib/helpers/formatPrice';

export const getFormattedPtsPrice = (priceType, units, masterAdStatus, isMobile) => {
    const activeAndUnsoldUnits = units.filter(unit => [AD_ACTIVE].includes(unit.adStatus) && !unit.isSold);
    // if master is active, only show price range for active and unsold units, otherwise show for all units
    const unitsToDisplay = [AD_ACTIVE_BUT_HIDDEN, AD_ACTIVE].includes(masterAdStatus) ? activeAndUnsoldUnits : units;

    const allSoldUnit = units.filter(unit => unit.isSold).length === units.length && units.length !== 0;

    if (unitsToDisplay.length === 0) {
        return allSoldUnit ? 'Solgt' : 'Pris kommer';
    }
    if (unitsToDisplay.length === 1) {
        if (priceType === 'totalPrice') {
            return `${formatPriceLabel(unitsToDisplay[0].totalPrice)}`;
        }
        return `${formatPriceLabel(unitsToDisplay[0].priceSuggestion)}`;
    }

    const totalPrices = unitsToDisplay.map(unit => {
        if (priceType === 'totalPrice') {
            return unit.totalPrice;
        }
        return unit.priceSuggestion;
    });

    const minPrice = totalPrices.reduce((a, b) => Math.min(a, b));
    const maxPrice = totalPrices.reduce((a, b) => Math.max(a, b));

    if (minPrice === maxPrice) {
        return `${formatPriceLabel(minPrice)}`;
    }
    if (isMobile && priceType === 'priceSuggestion') {
        return { minPrice: `${formatPriceLabel(minPrice)}`, maxPrice: `${formatPriceLabel(maxPrice)}` };
    }
    return `${formatPriceLabel(minPrice)} - ${formatPriceLabel(maxPrice)}`;
};
